export default __webpack_public_path__ + "static/media/BG-Yellow-0005.706857fa.png";